import React from 'react'
import { Divider } from 'semantic-ui-react'

export const FullLoaded = () => {
    return (
        <>
            <Divider />
            No more postings to load ... create some more?
        </>
    )
}
